import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { LanguageProvider } from "./lib/i18n";
import { AdminAuthProvider } from "./lib/adminAuth";
import { SiteContentProvider } from "./lib/siteContent";
import { CartProvider } from "./lib/cart";
import Layout from "./components/layout/Layout";
import Home from "./pages/Home";
import Services from "./pages/Services";
import About from "./pages/About";
import Blog from "./pages/Blog";
import BlogDetail from "./pages/BlogDetail";
import Events from "./pages/Events";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminLayout from "./pages/admin/AdminLayout";
import AdminMessages from "./pages/admin/AdminMessages";
import AdminHome from "./pages/admin/AdminHome";
import AdminServices from "./pages/admin/AdminServices";
import AdminEvents from "./pages/admin/AdminEvents";
import AdminContactInfo from "./pages/admin/AdminContactInfo";
import AdminOrders from "./pages/admin/AdminOrders";
import AdminCourses from "./pages/admin/AdminCourses";
import Trainings from "./pages/Trainings";
import TrainingDetail from "./pages/TrainingDetail";
import TrainingWatch from "./pages/TrainingWatch";
import Cart from "./pages/Cart";

function App() {
  return (
    <LanguageProvider>
      <CartProvider>
      <AdminAuthProvider>
        <SiteContentProvider>
          <div className="App">
            <BrowserRouter>
              <Routes>
                {/* Public site */}
                <Route element={<Layout />}>
                  <Route path="/" element={<Home />} />
                  <Route path="/services" element={<Services />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/blog" element={<Blog />} />
                  <Route path="/blog/:slug" element={<BlogDetail />} />
                  <Route path="/events" element={<Events />} />
                  <Route path="/contact" element={<Contact />} />
                  <Route path="/trainings" element={<Trainings />} />
                  <Route path="/trainings/:slug" element={<TrainingDetail />} />
                  <Route path="/cart" element={<Cart />} />
                  <Route path="/team" element={<Navigate to="/" replace />} />
                </Route>

                {/* Watch sayfası — layout'suz, tam ekran */}
                <Route path="/trainings/:slug/watch" element={<TrainingWatch />} />

                {/* Admin */}
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminLayout />}>
                  <Route index element={<AdminMessages />} />
                  <Route path="home" element={<AdminHome />} />
                  <Route path="services" element={<AdminServices />} />
                  <Route path="events" element={<AdminEvents />} />
                  <Route path="orders" element={<AdminOrders />} />
                  <Route path="courses" element={<AdminCourses />} />
                  <Route path="contact-info" element={<AdminContactInfo />} />
                </Route>
              </Routes>
          </BrowserRouter>
          <Toaster
            position="top-right"
            toastOptions={{
              style: {
                background: "#FFFFFF",
                color: "#2C3531",
                border: "1px solid #E5E0D8",
                fontFamily: "Outfit, sans-serif",
              },
            }}
          />
        </div>
        </SiteContentProvider>
      </AdminAuthProvider>
      </CartProvider>
    </LanguageProvider>
  );
}

export default App;
